"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports["default"] = void 0;
var _SessionStates = require("../../constants/SessionStates");
var _types = require("../../actions/sessionState/types");
var initialState = exports.initialState = _SessionStates.SESSION_NOT_READY;
function sessionState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === _types.BROADCAST_SET_SESSION_STATE) return action.payload;
  return state;
}
var _default = exports["default"] = sessionState;